// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"styles_widgetContainer__2A6o1","table":"styles_table__2fJ-m","code":"styles_code__26p81"};